module.exports = __webpack_public_path__ + "img/TechFishingBoat1_ua.c97741a4.webp";